import { __assign, __rest } from "tslib";
import React from 'react';
import Position from './Position';
/** @type {any} */
var PinCenter = React.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Position, __assign({ left: "50%", position: "absolute", ref: ref, top: "50%", transform: "translate(-50%, -50%)" }, props), children));
});
export default PinCenter;
